import {React, observer, classNames, useMemo, useCallback} from '@api'
import {Icon, InputGroupProps2, MenuItem, Spinner} from '@blueprintjs/core'
import {SearchSharp} from '@material-ui/icons'
import {ErrorBoundaryToast, StoresInstanceContext} from '@modules'
import {useStores} from '@modules/VipLocalStore'
import {removeUndefinedsNested} from '@utils'
import {CatalogSuggestResult, ICatalogSearchResult, CatalogSuggest} from './'

import {IItemRendererProps} from '@blueprintjs/select'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './CatalogSearchBar.css'

export const CatalogSearchBar = observer<{ className?: string, inModal?: boolean }>(function CatalogSearchBar({className, inModal}) {
  const stores = useStores(),
    {
      flexLayout: {activeOrLastCatalogRoot: catalogRoot, isMaximized},
    } = stores,
    {
      strings, catalog: {
        searcher,
        searcher: {
        searchQueryText, searchResults, clearSearch, onQueryChange, onItemSelect, onActiveItemChange, onKeyDown,
        activeResult, setSuggestRef, loading, onPopoverOpened, onPopoverClosed, selectedItem
      },
      sidebar
    }} = catalogRoot?.storesToInject ?? stores,
    inputValueRenderer = useCallback(() => {
      return searcher.searchQueryText
      // console.log(`inputValueRenderer`, item)
      // return `${item.title} (${_.startCase(item.type)})`
      // return <div className={css.inputValue}>
      //   <span className={css.type}>{item.type}</span>
      //   <span className={css.label}>{item.label}</span>
      // </div>
    }, [searcher]),
    itemRenderer = useCallback((item: ICatalogSearchResult, props: IItemRendererProps) => {
      return <CatalogSuggestResult key={item.key ?? props.index} item={item} {...props} />
    }, []),
    inputProps = useMemo(() => {
      return {
        leftElement: <SearchSharp className={css.searchIcon}/>,
        //<Spinner size={20} /> // use suspense to wait a bit before showing this, gets annoying during collection nav
        rightElement: <PrimaryIconButton wrapperClassName={css.clearIcon} icon={loading ? <Spinner /> : 'cross'} onClick={searchQueryText && !loading ? clearSearch : undefined}/>,
        placeholder: `${strings.search}...`,
        onKeyDown: onKeyDown(inModal),
      } as InputGroupProps2
    }, [loading, !searchQueryText, inModal])

  // console.log({store: stores._id, activeResult, searchQueryText, selectedItem, searchResults})

  if (!catalogRoot) return null

  //return null  // This component causes huge layout passes to happen due to the input group always measuring itself for left and right elements - need to remove those elements and do them inline and retest performance before reenabling
  return (
    <StoresInstanceContext.Provider value={catalogRoot?.storesToInject}>
    <ErrorBoundaryToast>
    <form className={classNames(css.root, className)} autoComplete='off'>
      <CatalogSuggest
        ref={setSuggestRef}
        className={css.suggest}
        inputProps={inputProps}
        popoverProps={removeUndefinedsNested({
          minimal: true,
          popoverClassName: css.popover,
          onOpened: onPopoverOpened,
          onClosed: onPopoverClosed,
          isOpen: (isMaximized && !inModal && sidebar.right.open && sidebar.right.type == 'modal') ? false : undefined,
          ...MenuItem.defaultProps.popoverProps
        })}
        onQueryChange={onQueryChange}
        onActiveItemChange={onActiveItemChange}
        query={searchQueryText}
        items={searchResults}
        selectedItem={selectedItem}
        //initialContent={site._searchText}
        resetOnSelect={false}
        closeOnSelect={false}
        inputValueRenderer={inputValueRenderer}
        //itemListRenderer={itemListRenderer}
        itemRenderer={itemRenderer}
        onItemSelect={onItemSelect}
        scrollToActiveItem
        activeItem={activeResult}
      />
    </form>
    </ErrorBoundaryToast>
    </StoresInstanceContext.Provider>
  )
})



// WEBPACK FOOTER //
// ./src/modules/catalogSearcher/CatalogSearchBar.tsx